module.exports = __webpack_public_path__ + "img/rtaw-system-image.7511c551.png";